<a [routerLink]="item.children?.length ? null : [item.route]" (click)="toggleExpand($event)" [class.active]="isActive()"
  class="nav-link flex items-center py-2.5 my-1 text-[13.5px] font-medium cursor-pointer relative overflow-hidden transition-all duration-300"
  [class.px-4]="!isCollapsed"
  [class.gap-3]="!isCollapsed"
  [class.justify-center]="isCollapsed"
  [class.px-0]="isCollapsed">

  <!-- Icon Wrapper -->
  <div class="nav-icon flex items-center justify-center flex-shrink-0 z-10 transition-all duration-300"
    [class.w-5]="!isCollapsed"
    [class.h-5]="!isCollapsed"
    [class.w-7]="isCollapsed"
    [class.h-7]="isCollapsed"
    [class.scale-110]="isActive()">
    <span class="iconify transition-all duration-300" 
      [class.text-lg]="!isCollapsed"
      [class.text-xl]="isCollapsed"
      [attr.data-icon]="item.icon"></span>
  </div>

  <!-- Label -->
  <span class="nav-label z-10 truncate transition-all duration-300 transform-gpu origin-left"
    [class.flex-1]="!isCollapsed"
    [ngClass]="isCollapsed ? 'opacity-0 scale-95 translate-x-[-20px] invisible w-0' : 'opacity-100 scale-100 translate-x-0 visible ml-0'">
    {{ item.label || item.displayName }}
  </span>

  <!-- Arrow icon for expanding children -->
  <div class="ml-auto z-10 transition-all duration-300"
    [ngClass]="isCollapsed ? 'opacity-0 scale-0 invisible' : 'opacity-100 scale-100 visible'"
    *ngIf="item.children?.length">
    <span class="iconify text-sm transition-transform duration-200" [class.rotate-180]="expanded()"
      data-icon="solar:alt-arrow-down-linear"></span>
  </div>
</a>

<!-- Children sub-items -->
<div *ngIf="expanded() && item.children?.length && !isCollapsed" class="pl-4">
  <div *ngFor="let child of item.children">
    <app-nav-item [item]="child" [depth]="depth + 1"></app-nav-item>
  </div>
</div>